export default "__VITE_ASSET__C8gs33TF__"